import { AppRouter } from 'app/router';
import { CookiesModal } from 'modules/landingPage';
import { Theme } from 'modules/ui';
import React from 'react';

import './translations/initTranslation';

function App() {
  return (
    <Theme>
      <AppRouter />
      <CookiesModal />
    </Theme>
  );
}

export default App;
